import * as React from 'react';
import { Container } from '../helpers/Grid';
import CompetitionScheduleProps, {
  CompetitionDayEvents,
  CompositionDayEvent,
} from './type';
import './styles.scss';

export const CompetitionScheduleEvent = ({
  category,
  raceClass,
  raceName,
  raceType,
}: CompositionDayEvent) => (
  <div className="competition-schedule-event">
    <div className="competition-schedule-event__title">
      <div className="competition-schedule-event__name">
        {raceName}
      </div>
      <div className="competition-schedule-event__type">
        {raceType}
      </div>
    </div>
    <div className="competition-schedule-event__details">
      <div className="competition-schedule-event__category">
        {category}
      </div>
      <div className="competition-schedule-event__class">
        {raceClass}
      </div>
    </div>
  </div>
);

export const CompetitionScheduleDayEvents = ({
  date,
  races,
}: CompetitionDayEvents) => (
  <div className="competition-schedule-day">
    <div className="competition-schedule-day__date">
      <h3>{date}</h3>
    </div>
    <div className="competition-schedule-day__races">
      {races.map((race) => (
        <CompetitionScheduleEvent {...race} />
      ))}
    </div>
  </div>
);

const CompetitionSchedule = ({
  title,
  items,
}: CompetitionScheduleProps) => (
  <section className="competition-schedule">
    <Container>
      <div className="competition-schedule__inner">
        <div className="competition-schedule__title">
          <h1>{title}</h1>
        </div>
        <div className="competition-schedule__days">
          {items.map((day) => <CompetitionScheduleDayEvents {...day} />)}
        </div>
      </div>
    </Container>
  </section>
);

export default CompetitionSchedule;
